import React, { useState, useContext } from "react";
import './posture.css';
import { Icon, Button } from "@abb/abb-common-ux-react";
import NotificationExample from "../../../components/Notification/notification";
import JsonData from './posture.json';
import { FILE_UPLOAD_API_URL, Posture_BASE_API_URL, CYBERSHIELD_BASE_API_URL } from "../../../strings";
import { RootContext } from "../../../contexts/root-context";
import { getToken } from "../../../components/Authentication/get-token";


function SBOMUploader() {
    const { setShowConfigureSBOMPage } = useContext(RootContext);

    const [isnotify, setisnotify] = useState("");
    const [selectedSBOMFile, setSelectedSBOMFile] = useState(null);
    const [sbomFileLastUpdated, setSbomFileLastUpdated] = useState("");
    const [sbomFileChanged, setSbomFileChanged] = useState(false);
    const [isUploadingSBOM, setIsUploadingSBOM] = useState(false);

    // 🔧 Removed unused sbomFileURL, uploadedSBOM, isSBOMUploaded, error

    const goBack = () => {
        setShowConfigureSBOMPage(false);
    };

    const getAuthHeaders = () => {
        const tokenObj = getToken();
        return {
            "Content-Type": "application/json",
            ...(tokenObj?.headers || {}),
        };
    };

    const handleSBOMFileChange = (e) => {
        const file = e.target.files[0];
        e.target.value = "";

        if (file) {
            const validTypes = JsonData.fileTypes;
            setisnotify("");

            if (file.size > 5 * 1024 * 1024) {
                setisnotify(JsonData.notifications.SbomTooLarge);
                return;
            }

            if (!validTypes.includes(file.type)) {
                setisnotify(JsonData.notifications.sbominvalidFormat);
                return;
            }

            setSelectedSBOMFile(file);
            setSbomFileLastUpdated(new Date().toISOString());
            setSbomFileChanged(true);
        }
    };

    // const uploadSBOMFile = async () => {
    //     if (!selectedSBOMFile || !(selectedSBOMFile instanceof Blob)) {
    //         console.error("Selected SBOM file is invalid or not of type Blob.");
    //         setisnotify(JsonData.notifications.sbomuploadFailed);
    //         return;
    //     }

    //     const reader = new FileReader();
    //     reader.onload = async (event) => {
    //         const base64 = event.target.result.split(",")[1];

    //         const payload = {
    //             body: base64,
    //             isBase64Encoded: true
    //         };

    //         try {
    //             const response = await fetch(Posture_BASE_API_URL, {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify(payload)
    //             });

    //             if (response.ok) {
    //                 const data = await response.json();
    //                 const fileName = data.file_name;
    //                 localStorage.setItem("selectedSBOMFile", fileName);
    //                 postFileNameFromLocalStorage();
    //             } else {
    //                 setisnotify(JsonData.notifications.sbomuploadFailed);
    //             }
    //         } catch (err) {
    //             console.error("SBOM upload error:", err);
    //             setisnotify(JsonData.notifications.sbomuploadFailed);
    //         }
    //     };
    //     reader.readAsDataURL(selectedSBOMFile);
    // };

    const uploadSBOMFile = async () => {
    if (!selectedSBOMFile || !(selectedSBOMFile instanceof Blob)) {
        console.error("Selected SBOM file is invalid or not of type Blob.");
        setisnotify(JsonData.notifications.sbomuploadFailed);
        return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
        const base64 = event.target.result.split(",")[1];

        // const payload = {
        //     files: [
        //         {
        //             fileName: selectedSBOMFile.name,
        //             data: base64,
        //             metadata: {
        //                 projectName: "cybershield",
        //                 fileType: "sbom"
        //             }
        //         }
        //     ]
        // };
     const payload = {
        files: [
            {
            fileName: selectedSBOMFile.name,
            data: base64,
            projectName: "cybershield",
            fileType: "SBOMFiles",
            },
        ],
        };

        try {
            const response = await fetch(FILE_UPLOAD_API_URL, {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json();
                const fileName = data.file_name || selectedSBOMFile.name;
                localStorage.setItem("selectedSBOMFile", fileName);
                postFileNameFromLocalStorage();
            } else {
                setisnotify(JsonData.notifications.sbomuploadFailed);
            }
        } catch (err) {
            console.error("SBOM upload error:", err);
            setisnotify(JsonData.notifications.sbomuploadFailed);
        }
    };

    reader.readAsDataURL(selectedSBOMFile);
};


    const postFileNameFromLocalStorage = async () => {
        const fileName = localStorage.getItem("selectedSBOMFile");
        if (!fileName) {
            console.error("No SBOM file name found in localStorage.");
            return;
        }

        const payload = { file_list: [fileName] };

        try {
            const response = await fetch(
                // PostureGetFileNmae_BASE_API_URL, 
                `${CYBERSHIELD_BASE_API_URL}/SbomScanner-ScanTrigger`,
                
                {
                method: "POST",
                headers:getAuthHeaders(),
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                console.log("Posture score API success:", result);
            } else {
                console.error("Posture score API error:", await response.text());
            }
        } catch (err) {
            console.error("Network error:", err);
        }
    };

    const handleUpload = async () => {
        if (!selectedSBOMFile || !sbomFileChanged) return;

        setisnotify(JsonData.notifications.sbomuploadInProgress);
        setIsUploadingSBOM(true);

        try {
            await uploadSBOMFile();

            setisnotify(JsonData.notifications.sbomuploadSuccess);
            setTimeout(() => setisnotify(""), 3000);
        } catch (err) {
            console.error("SBOM upload operation failed:", err);
            setisnotify(JsonData.notifications.sbomuploadFailure);
            setTimeout(() => setisnotify(""), 3000);
        } finally {
            setIsUploadingSBOM(false);
            setSbomFileChanged(false);
        }
    };

    const getTimeAgo = (date) => {
        const current = new Date();
        const past = new Date(date);
        const seconds = Math.floor((current - past) / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        if (months > 0) return `${months} month${months > 1 ? "s" : ""} ago`;
        if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
        if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
        if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
        if (seconds > 0) return `${seconds} sec${seconds > 1 ? "s" : ""} ago`;
        return "Just now";
    };

    const sbomFileDisplay = selectedSBOMFile && (
        <>
            <b>{selectedSBOMFile.name}</b>
            <Icon className="uploaded" name="abb/check-mark-circle-1" />
            <span className="sbom-file-upload-notification">
                {JsonData.labels.lastUpdated}: {sbomFileLastUpdated ? getTimeAgo(sbomFileLastUpdated) : "N/A"}
            </span>
        </>
    );

    const canUploadSBOM = selectedSBOMFile && sbomFileChanged && !isUploadingSBOM;

    return (
        <>
            {Object.values(JsonData.notifications).includes(isnotify) && (
                <NotificationExample notitype={isnotify} />
            )}

            <div className="sbom-bck-row">
            <button
            className="sbom-go-back"
            onClick={goBack}
            type="button"
            >
            <Icon sizeClass="small" name="abb/left-arrow" />
            {"  "}Back
            </button>

            </div>

            <div className="sbom-row">
                <span className="sbom-inside-header">{JsonData.labels.uploadSBOM}</span>
            </div>

            <div className="sbom-row">
                <input
                    type={JsonData.inputData.type}
                    accept={JsonData.inputData.fileAcceptedTypes}
                    id={JsonData.inputData.id}
                    className="sbom-file"
                    onChange={handleSBOMFileChange}
                />
            </div>

            <span style={{ display: "flex", fontSize: "12px", marginTop: "2px", marginBottom: "10px" }}>
                {sbomFileDisplay}
            </span>

            <div className="sbom-row">
                <div className="sbom-button_row">
                    <Button
                        text={isUploadingSBOM ? JsonData.labels.uploading : JsonData.labels.uploadButton}
                        disabled={!canUploadSBOM}
                        shape={JsonData.ButtonData.shape}
                        sizeClass={JsonData.ButtonData.sizeClass}
                        type={JsonData.ButtonData.type}
                        onClick={handleUpload}
                    />
                </div>
            </div>
        </>
    );
}

export default SBOMUploader;
